import { wrapApiCall } from '@/lib/axios'
import type { AxiosInstance } from 'axios'
import type {
  MemberTaxInvoiceData,
  TaxInvoiceBusiness,
  TaxInvoicePersonal,
  TaxInvoiceRequestPayload,
} from './model'

export const TaxInvoiceService = (client: AxiosInstance) => {
  return {
    async getMemberTaxInvoice(memberId: string | number): Promise<MemberTaxInvoiceData> {
      const { data } = await wrapApiCall(() =>
        client.get<MemberTaxInvoiceData>(`/members/${memberId}/tax-invoice`)
      )
      return data
    },

    async updateMemberTaxInvoice(
      memberId: string | number,
      payload: { personal?: TaxInvoicePersonal; business?: TaxInvoiceBusiness }
    ): Promise<MemberTaxInvoiceData> {
      const { data } = await wrapApiCall(() =>
        client.patch<MemberTaxInvoiceData>(`/members/${memberId}/tax-invoice`, payload)
      )
      return data
    },

    async requestTaxInvoice(payload: TaxInvoiceRequestPayload): Promise<void> {
      await wrapApiCall(() => client.post('/tax-invoice-request', payload))
    },

    async sendReceiptEmail(
      receiptId: string | number,
      payload: { email: string; saveToProfile: boolean }
    ): Promise<void> {
      await wrapApiCall(() => client.post(`/receipt/${receiptId}/send-email`, payload))
    },
  }
}
